var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotProcessed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.1 20.7c-.1 0-.4 0-.5-.1L13 13.9l-6.6 6.6c-.3.3-.7.3-1 0s-.3-.7 0-1l6.6-6.6-6.6-6.5c-.1-.3-.1-.7 0-1s.7-.3 1 0L13 12l6.6-6.6c.3-.3.7-.3 1 0s.3.7 0 1L14 13l6.6 6.6c.3.3.3.7 0 1-.1.1-.4.1-.5.1"
})));
export default SvgNotProcessed;